

const insults = [
	"You have issues",
];


export const getRandomInsult = () => {
	return insults[Math.floor(Math.random() * insults.length)];
};